<template>
  <v-list
    class="navigation-list"
    flat>
    <v-list-item
      :to="item.to"
      :exact="item.exact"
      active-class="active"
      :ripple="false"
      v-for="item in navigations"
      style="white-space: nowrap"
      class="navigation-list-item"
      :key="item.title">
      <span  class="mr-7"><v-icon size="17" class="mt-n1">{{item.icon}}</v-icon></span>{{item.title}}
    </v-list-item>
  </v-list>
</template>

<script>
  import {ROLES} from "@/utils/constants";

  export default {
    data() {
      return {
        navigations: []
      }
    },
    computed: {
      role() {
        return this.$store.getters.role
      }
    },
    methods: {
      setNavigation() {
        let navigations = []
        if (this.role === ROLES.mko) {
          navigations = [
            {
              to: {name: "dashboard"},
              title: "Главная",
              exact: true,
              icon: "fas fa-tachometer-alt"
            },
            {
              to: {name: "credit-index"},
              title: "Кредиты",
              icon: "fas fa-credit-card"
            },
            {
              to: {name: "debtors-index"},
              title: "Просроченные",
              icon: "fas fa-user-clock"
            },
            {
              to: {name: "credit-calculator"},
              title: "Скоринг",
              icon: "fas fa-calculator"
            },
            {
              to: {name: "mko-index"},
              title: "Филиалы",
              icon: "fas fa-ethernet"
            },
            {
              to: {name: "workers-index"},
              title: "Сотрудники",
              icon: "fas fa-users"
            },
            {
              to: {name: "tariff-index"},
              title: "Тарифы",
              icon: "fas fa-poll-h"
            },
            {
              to: {name: "transactions-index"},
              title: "Журнал транзакций",
              icon: "fas fa-file-invoice-dollar"
            },
            {
              to: {name: "black-list-index"},
              title: "Черный список",
              icon: "fas fa-ban"
            },
            {
              to: {name: "report-index"},
              title: "Отчёт",
              icon: "fas fa-info"
            },
          ]
        } else if (this.role === ROLES.superAdmin) {
          navigations = [
            {
              to: {name: "mko-index"},
              title: "Филиалы",
              icon: "fas fa-ethernet"
            },
            {
              to: {name: "report-index"},
              title: "Отчёт",
              icon: "fas fa-info"
            },
            {
              to: {name: "tariff-index"},
              title: "Тарифы",
              icon: "fas fa-poll-h"
            },
            {
              to: {name: "price-index"},
              title: "Цены",
              icon: "fas fa-dollar-sign"
            },
            {
              to: {name: "katm-users-index"},
              title: "Катм пользователи",
              icon: "fas fa-user"
            }
          ]
        }

        this.navigations = navigations
      }
    },
    created() {
      this.setNavigation()
    }
  }
</script>
